import { getAuthorValue } from 'z3k-parser/model/author';
export const dummyConfig = {
    //0
    analog_inputs: [],
    wired_temperature_sensors: [],
    guard_zones: [],
    notifications: [],
    users: [],
    //5
    output_actions: [],
    boiler_adapters: [],
    radiomodules: [],
    radiosensors: [],
    commands: [],
    //10
    web_elements: [],
    scenarios: [],
    buzzers: [],
    guard_indicators: [],
    relay_controls: [],
    //15
    threeway_taps: [],
    heating_circuits: [],
    pumps: [],
    tm_keys: [],
    user_roles: [],
    //20
    heating_modes: [],
    day_timetables: [],
    week_timetables: [],
    //radio_tags: [],
    io_extensions: [],
    //25
    pzas: [],
    boiler_groups: [],
    analog_temperature_sensors: [],
    ntc_temperature_curves: [],
    fobs: [],
    //30
    fob_buttons: [],
    radiosensors433: [],
    //outer_panels: [],
    time_intervals: [],
    interval_timetables: [],
    //35
    analog_duts: [],
    calibration_tables: [],
    digital_duts: [],
    radio_duts: [],
    graph_panels: [],
    //40
    boiler_cascades: [],
    //dut_settings: [],
    ui_groups: [],
    object_arrays: [],
    //accelerometrs: [],
    //45
    pauses: [],
    conditional_operators: [],
    comparators: [],
    logic_expressions: [],
    sensor_readings: [],
    //50
    time_comparators: [],
    modbus_devices: [],
    modbus_signals: [],
    analog_outputs: [],
    //signals: [],
    //55
    //slots: [],
    stop_scenarios: [],
    mqtt_topics: [],
};
export const object_types = Object.keys(dummyConfig);
export function getZ3kEntityById(config, object_id) {
    for (let i = 0; i < object_types.length; ++i) {
        const partial_of_z3k_config = config[object_types[i]];
        if (partial_of_z3k_config != null)
            for (let j = 0; j < (partial_of_z3k_config || []).length; ++j) {
                const foundObj = partial_of_z3k_config[j];
                if (foundObj.id === object_id) {
                    return [object_types[i], foundObj];
                }
            }
    }
    return [null, null];
}
export function genIdAndIncCounter(config) {
    let counter = config.counters[Z3K_CONFIG_AUTHOR];
    const all_ids = Object.fromEntries(object_types.flatMap((type) => (config[type] || []).map((obj) => [obj.id, true])));
    while (all_ids[getAuthorValue(Z3K_CONFIG_AUTHOR) | counter])
        counter = (counter + 1) & 0xfff;
    return [
        (getAuthorValue(Z3K_CONFIG_AUTHOR) | counter),
        {
            ...config,
            counters: {
                ...config.counters,
                [Z3K_CONFIG_AUTHOR]: (counter + 1) & 0xfff,
            },
        },
    ];
}
